var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-hotmart-for-me-form"},[_c('div',{staticClass:"is-hotmart-for-me-form__container"},[_c('iframe',{attrs:{"src":"https://survey.alchemer.com/s3/6889230/en-is-hotmart-for-me","frameborder":"0"}})])])
}]

export { render, staticRenderFns }